export const defaultTheme = {
    colors: {
        primary: '#ffffff',

        'warn-shopping': '#FFEDA6',
        'text-warn': '#453B1E',

        'supernova-100': '#FFFEC1',
        'supernova-400': '#FFDE0D',
        'supernova-500': '#FFCF00',
        'supernova-600': '#D19800',
        'supernova-700': '#A66C02',
        'supernova-950': '#442404',

        'silver-100': '#EDEDED',
        'silver-200': '#DFDFDF',
        'silver-300': '#C4C4C4',
        'silver-500': '#999',
        'silver-700': '#7B7B7B',

        'neutral-0': '#FFFFFF',
        'neutral-50': '#FAFAFA',
        'neutral-100': '#F4F4F5',
        'neutral-200': '#E4E4E7',
        'neutral-300': '#D4D4D8',
        'neutral-400': '#A1A1AA',
        'neutral-500': '#71717A',
        'neutral-600': '#52525B',
        'neutral-800': '#27272A',
        'neutral-900': ' #18181B',
        'neutral-950': '#09090B',
        'green-300': '#22c55e',
        'orange-300': '#f97316',
        'red-300': '#f43f5e',

        'neutral-400-opacity': 'rgba(161, 161, 170, 0.5)',
        'neutral-950-opacity': '#09090B80',
    },
};
